import { RepositorioBase } from "@/http"
import {
  AlterarMarcacao,
  CriarMarcacao,
  MarcacaoCriada,
} from "./marcacoes.modelos"

class MarcacoesRepositorio extends RepositorioBase {
  public criarMarcacao = (
    idAtividadeRealizada: string,
    marcacao: CriarMarcacao
  ): Promise<MarcacaoCriada> =>
    this.instance.post(
      `/api/atividades-realizadas/${idAtividadeRealizada}/marcacoes`,
      marcacao
    )

  public alterarMarcacao = (
    idAtividadeRealizada: string,
    idMarcacao: string,
    marcacao: AlterarMarcacao
  ): Promise<MarcacaoCriada> =>
    this.instance.patch(
      `/api/atividades-realizadas/${idAtividadeRealizada}/marcacoes/${idMarcacao}`,
      marcacao
    )

  public removerMarcacao = (
    idAtividadeRealizada: string,
    idMarcacao: string
  ): Promise<void> =>
    this.instance.delete(
      `/api/atividades-realizadas/${idAtividadeRealizada}/marcacoes/${idMarcacao}`
    )
}

export default MarcacoesRepositorio
